import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { AuthInterceptor } from "./intercepters/authInterceptor";
import { CacheInterceptor } from "./intercepters/cacheIntercepter";
import { RouterModule } from "@angular/router";
import { SetDefaultModuleDirective } from "./directives/set-default-module.directive";

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule,
    SetDefaultModuleDirective
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
  ],
  exports: [
    SetDefaultModuleDirective
  ]
})

export class CoreModule { }
